<template>
  <div :style="input.disabled || input.readonly ? 'pointer-events: none;' : ''">
    <input
      type="text"
      :class="'form-control ' + input.class"
      :value="value"
      @input="(e) => handleChange(e)"
      :placeholder="input.placeholder"
      :required="!input.optional"
      :disabled="input.disabled"
      :readonly="input.readonly"
      :name="input.name"
      :id="input.id ? input.id : input.name"
    />
  </div>
</template>
<script>
export default {
  name: "InputText",
  components: {},
  props: {
    input: Object,
    value: String,
  },
  data: function() {
    return {};
  },
  beforeRouteUpdate() {
    this.value = null;
  },
  methods: {
    handleChange(e) {
      this.$emit("handleChange", e);
    },
  },
};
</script>
